import { Suspense } from "react";
import { Button, Divider, Portal, styled } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

import { useUuidLayoutContext } from "hooks/routerHooks";

import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";
import { MeasuresAndStudyArea } from "components/map/MeasuresAndStudyArea";
import { UploadIcon } from "components/icons/UploadIcon";
import { DrawPolygon } from "components/icons/DrawPolygon";
import { DrawOrUploadMeasureFooter } from "components/footer/DrawOrUploadMeasureFooter";
import { NavLink } from "components/navigation/NavLink";

export function DrawOrUploadMeasurePage() {
  const { t } = useTranslation();
  const { mapRef, uuid, footerRef } = useUuidLayoutContext();

  return (
    <StyledPaddedPaper>
      <Button
        to="group"
        component={NavLink}
        variant="text-icon"
        startIcon={<DrawPolygon />}
      >
        {t("label.drawMeasureYourself")}
      </Button>
      <Divider>{t("label.or")}</Divider>
      <Button
        to="upload"
        variant="text-icon"
        startIcon={<UploadIcon />}
        component={NavLink}
      >
        {t("label.uploadAShapefile")}
      </Button>
      <Suspense>
        <ErrorBoundary
          FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
        >
          <MeasuresAndStudyArea mapRef={mapRef} uuid={uuid} />
        </ErrorBoundary>
      </Suspense>
      <Portal container={footerRef}>
        <DrawOrUploadMeasureFooter />
      </Portal>
    </StyledPaddedPaper>
  );
}
const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(2)};
  padding-left: ${({ theme }) => theme.spacing(5)};
  .MuiButton-root {
    width: fit-content;
  }
  .MuiDivider-root {
    max-width: 50%;
  }
`;
